var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupUsersProfiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0198 15.4265L12.0201 13.0162C12.0202 11.6848 10.9409 10.6055 9.60952 10.6055H4.21159C2.88039 10.6055 1.8012 11.6845 1.80105 13.0157L1.80078 15.4265M16.2006 15.4267L16.2008 13.0163C16.2009 11.685 15.1216 10.6056 13.7902 10.6056M11.5555 3.04387C12.1475 3.4831 12.5311 4.18724 12.5311 4.98098C12.5311 5.77473 12.1475 6.47887 11.5555 6.9181M9.37113 4.98085C9.37113 6.31216 8.29189 7.3914 6.96059 7.3914C5.62928 7.3914 4.55005 6.31216 4.55005 4.98085C4.55005 3.64955 5.62928 2.57031 6.96059 2.57031C8.29189 2.57031 9.37113 3.64955 9.37113 4.98085Z",
    stroke: "#555555",
    strokeWidth: 1.53,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupUsersProfiles);
export default __webpack_public_path__ + "static/media/GroupUsersProfiles.e4286ab8176fba5edb9c4b0de3dbf1e2.svg";
export { ForwardRef as ReactComponent };